<template>
  <button
    class="menu__item__link"
    :class="{'menu__item__link--highlight' : highlight}"
    v-on="$listeners"
  >
    <span class="menu__item__inner">
      <slot />
    </span>
  </button>
</template>

<script>
  export default {
    props: {
      highlight: { type: Boolean, default: false }
    }
  }
</script>


<style scoped lang="scss">
  @import "~@/assets/sass/variables";

  .menu__item__link {
    position: relative;
    display: inline-block;
    font-size: 0.89rem;
    cursor: pointer;
    user-select: none;
    text-align: left;

    .menu__item__inner {
      color: $white300;
      position: relative;

      &:hover {
        color: darken($white300, 10);
      }

      a {
        color: $white300;

        &:hover {
          color: darken($white300, 10);
        }
      }
    }
  
    &--highlight .menu__item__inner {
      &:after {
        content: 'novo!';
        position: absolute;
        right: 0;
        top: -15px;
        background: $highlightPrimaryColor;
        font-size: 10px;
        padding: 0 6px;
        border-radius: 30px;
        color: $purple900;
      }
    }
  }

  .menu--vertical .menu__item__link {
    font-size: 0.89rem;
    padding: 10px 0;

    &--highlight > *:after {
      transform: translateY(-50%);
      top: 50%;
      right: auto;
      left: 100%;
      margin-left: 10px;
    }
  }
</style>